export const messages = {
  lang: "en",
  dateLocale: "en-GB",
  loading: "Loading available times...",
  empty: "No times available at the moment.",
  emptyDate: "No times available on this date.",
  appointmentTitle: "Appointment",
  timezone: "Time zone",
  tzHourOf: "in",
  tzAt: "in",
  chooseDate: "Choose a day",
  chooseSlot: "What time suits you?",
  slotsFor: "Times for",
  pickDayFirst: "Choose a day to see available times.",
  slotAvailable: "Available",
  daySlotsOne: "{count} slot available",
  daySlotsMany: "{count} slots available",
  formTitle: "Your details",
  changeSlot: "Change",
  back: "Back",
  dateLabel: "Date",
  name: "Name",
  email: "Email",
  phone: "Phone",
  message: "Message",
  optional: "optional",
  fieldNameRequired: "Please enter your name.",
  fieldEmailInvalid: "Please enter a valid email address.",
  fieldPhoneRequired: "Please enter a phone number.",
  fieldMessageRequired: "Please enter a message.",
  privacyTitle: "Privacy",
  privacyDefaultNotice: "Your data is used only to process this appointment request.",
  privacyPolicyLabel: "Read the privacy policy",
  submit: "Book appointment",
  submitting: "Booking...",
  confirmationTitle: "Appointment confirmed",
  confirmationIntro: "Your slot is booked.",
  confirmationNext: "You will receive the details by email if notifications are enabled.",
  pendingTitle: "Confirm your appointment",
  pendingIntro: "Your request has been received. To confirm it, click the link we have just sent you by email.",
  pendingNext: "If you do not confirm, the slot will be released automatically. Please check your spam folder too.",
  validation: "Please check the highlighted fields.",
  network: "Service temporarily unavailable. Please try again later.",
  SLOT_UNAVAILABLE: "This time is no longer available. Please choose another one.",
  VALIDATION_ERROR: "Some information is invalid. Please check the form.",
  CALENDAR_ERROR: "Availability cannot be checked at the moment.",
  EMAIL_ERROR: "Your appointment is booked, but the confirmation email could not be sent.",
  INTERNAL_ERROR: "A technical error occurred. Please try again later.",
  TENANT_NOT_FOUND: "This booking service is not available.",
  RATE_LIMITED: "Too many attempts. Please wait a moment and try again.",
  MISSING_PUBLISHABLE_KEY: "Incomplete widget configuration (missing key).",
  INVALID_PUBLISHABLE_KEY: "Invalid widget configuration (key rejected).",
  KEY_TENANT_MISMATCH: "Invalid widget configuration (key from another account).",
  ORIGIN_NOT_ALLOWED: "This website is not authorised to display this booking widget."
};
